<template>
  <div id="annonce-create-step-right-part"
       class="row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 styled-scrollbar-custom pr-under-md-0 pl-under-md-0">
    <div id="annonce-create-step-right-part-inside" class="w-100">
      <div class="col-12 pl-0 pr-0 mb-5">
        <b-form-group
          :label="$t('annonce.vehicle.insurance.company')"
          class="small-text"
          label-for="insuranceCompany-input">
          <b-form-input
            id="insuranceCompany-input"
            v-model="insuranceCompany.value"
            :state="insuranceCompany.state"
            @change="setAnnonce">
          </b-form-input>
        </b-form-group>
      </div>

      <div class="col-12 pl-0 pr-0 mb-5">
        <b-form-group
          :label="$t('annonce.vehicle.insurance.contract')"
          class="small-text"
          label-for="insuranceContract-input">
          <b-form-input
            id="insuranceContract-input"
            v-model="insuranceContract.value"
            :state="insuranceContract.state"
            @change="setAnnonce">
          </b-form-input>
        </b-form-group>
      </div>
      <div v-if="isLicensed" class="col-12 pl-0 pr-0 mb-5">
        <b-form-group
          :invalid-feedback="carteGriseFile.invalidFeedback"
          :label="$t('annonce.vehicle.carteGrise')"
          :state="carteGriseFile.state"
          class="small-text form-group-with-label-legend"
          label-for="carteGriseFile-input">
          <div class="label-legend-text" v-html="$t('annonce.online.mandatory.field')"></div>
          <b-form-file
            id="carteGriseFile-input"
            ref="carteGriseFile-input"
            v-model="carteGriseFile.value"
            :browse-text="$t('Select')"
            :drop-placeholder="$t('drop-placeholder')"
            :placeholder="carteGriseFile.fileName"
            accept=".png, .jpeg, .jpg, .pdf"
            required
            @change="event => previewImage(event, 'carteGriseFile')"
            @input="setAnnonce($event, 'carteGriseFile')">
          </b-form-file>
          <PreviewOneFile :file="carteGriseFile" :imagePreviewSrc="imagePreviewCarteGriseFile"
                          :pdfPreviewSrc="pdfPreviewCarteGriseFile" fileId="carteGriseFile"
                          @deleteFileInPreview="deleteFileFromPreview"></PreviewOneFile>
        </b-form-group>
      </div>
      <div class="col-12 pl-0 pr-0 mb-5">
        <b-form-group
          :invalid-feedback="plainteFile.invalidFeedback"
          :label="$t('annonce.depotPlainte')"
          :state="plainteFile.state"
          class="small-text form-group-with-label-legend"
          label-for="plainteFile-input">
          <div class="label-legend-text" v-html="$t('annonce.online.mandatory.field')"></div>
          <b-form-file
            id="plainteFile-input"
            ref="plainteFile-input"
            v-model="plainteFile.value"
            :browse-text="$t('Select')"
            :drop-placeholder="$t('drop-placeholder')"
            :placeholder="plainteFile.fileName"
            accept=".png, .jpeg, .jpg, .pdf"
            required
            @change="event => previewImage(event, 'plainteFile')"
            @input="setAnnonce($event, 'plainteFile')">
          </b-form-file>
          <PreviewOneFile :file="plainteFile" :imagePreviewSrc="imagePreviewPlainteFile"
                          :pdfPreviewSrc="pdfPreviewPlainteFile" fileId="plainteFile"
                          @deleteFileInPreview="deleteFileFromPreview"></PreviewOneFile>
        </b-form-group>
      </div>
      <div class="col-12 pl-0 pr-0 mb-2">
        <span class="custom-span-files-mandatory"
              v-html="$t(isLicensed ? 'annonce.files.mandatory.licensed' : 'annonce.files.mandatory.not.licensed')"></span>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../services/api";
import PreviewOneFile from "../../../components/b122/showFields/PreviewOneFile";

export default {
  name: "AnnonceCreateStep7",

  components: {
    PreviewOneFile,
  },

  emits: ["updateAnnonce"],

  props: {
    annonce: {
      required: true,
      type: Object
    },
    isLicensed: {
      required: true,
    },
  },


  data() {
    return {
      carteGriseFile: {
        id: null,
        state: null,
        invalidFeedback: null,
        fileName: "",
        value: null
      },
      insuranceCompany: {
        state: null,
        value: null,
        invalidFeedback: null
      },
      insuranceContract: {
        state: null,
        value: null,
        invalidFeedback: null
      },
      plainteFile: {
        id: null,
        state: null,
        invalidFeedback: null,
        fileName: "",
        value: null
      },
      imagePreviewCarteGriseFile: null,
      pdfPreviewCarteGriseFile: null,
      imagePreviewPlainteFile: null,
      pdfPreviewPlainteFile: null,
      _blobUrls: []
    }
  },

  async mounted() {


    //carteGriseFile
    if (this.annonce.carteGriseFile.value) {
      this.carteGriseFile = this.annonce.carteGriseFile
      this.carteGriseFile.fileName = this.annonce.carteGriseFile.value.name

      this.setPreviewImageFromFile(this.annonce.carteGriseFile.value, 'carteGriseFile', true)

    } else if (this.annonce.carteGriseFile.id) {
      const candidateUrl = this.annonce.carteGriseFile.fileUrl
      const resolvedUrl = candidateUrl ? (this.isAlreadyResolvedUrl(candidateUrl) ? candidateUrl : await this.loadProtectedFile(candidateUrl)) : null
      this.carteGriseFile = {
        ...this.annonce.carteGriseFile,
        url: resolvedUrl || null
      }
    }

    //plainteFile
    if (this.annonce.plainteFile.value) {
      this.plainteFile = this.annonce.plainteFile
      this.plainteFile.fileName = this.annonce.plainteFile.value.name

      this.setPreviewImageFromFile(this.annonce.plainteFile.value, 'plainteFile', true)

    } else if (this.annonce.plainteFile.id) {
      const candidateUrl = this.annonce.plainteFile.fileUrl
      const resolvedUrl = candidateUrl ? (this.isAlreadyResolvedUrl(candidateUrl) ? candidateUrl : await this.loadProtectedFile(candidateUrl)) : null
      this.plainteFile = {...this.annonce.plainteFile, url: resolvedUrl || null}
    }

    // Insurance
    if (this.annonce.insuranceCompany) {
      this.insuranceCompany = this.annonce.insuranceCompany
    }
    if (this.annonce.insuranceContract) {
      this.insuranceContract = this.annonce.insuranceContract
    }
  },

  beforeDestroy() {
    this.cleanupBlobs()
  },

  methods: {
    pushBlobUrl(u) {
      if (!u) return u
      if (!this._blobUrls) this._blobUrls = []
      this._blobUrls.push(u)
      return u
    },

    cleanupBlobs() {
      if (this._blobUrls && this._blobUrls.length) {
        this._blobUrls.forEach(u => { try { window.URL.revokeObjectURL(u) } catch (e) {} })
      }
      this._blobUrls = []
    },

    isAlreadyResolvedUrl(u) {
      return typeof u === 'string' && (u.startsWith('blob:') || u.startsWith('data:') || u.startsWith('http://') || u.startsWith('https://'))
    },

    async loadProtectedFile(fileUrl) {
      try {
        const res = await api.get(fileUrl, { responseType: 'blob' })
        return this.pushBlobUrl(window.URL.createObjectURL(res.data))
      } catch (e) {
        return null
      }
    },

    setAnnonce(event, field) {
      if (event && event.size > 0 && event.name) {
        this[field].value = event
        this[field].fileName = event.name
        this[field].id = null
        this[field].state = null
        this[field].invalidFeedback = null
      }
      this.annonce[field] = this[field]
      this.annonce.insuranceCompany = this.insuranceCompany
      this.annonce.insuranceContract = this.insuranceContract
      this.$emit('updateAnnonce', this.annonce)
    },

    /** for carteGriseFile & plainteFile */
    previewImage(event, imageType) {

      // Référence au fichier
      const file = event.target.files[0]

      this.setPreviewImageFromFile(file, imageType, false)
    },

    /** for carteGriseFile & plainteFile */
    setPreviewImageFromFile(file, imageType, isInit) {
      var isPdf = file.type === "application/pdf"

      // Utilisation de FileReader pour lire le contenu du fichier
      const reader = new FileReader()

      reader.onload = () => {

        //Le contenu du fichier lu
        var base64 = reader.result

        var pdfPreview = isPdf ? base64 : null
        var imagePreview = !isPdf ? base64 : null

        //Mise à jour de la prévisualisation de l'image avec le contenu du fichier lu
        if (imageType === "carteGriseFile") {
          this.pdfPreviewCarteGriseFile = pdfPreview
          this.imagePreviewCarteGriseFile = imagePreview
          if (!isInit) {
            this.resetFileObject('carteGriseFile', false)
          }

        } else if (imageType === "plainteFile") {
          this.pdfPreviewPlainteFile = pdfPreview
          this.imagePreviewPlainteFile = imagePreview
          if (!isInit) {
            this.resetFileObject('plainteFile', false)
          }
        }
      };

      // Lecture du contenu du fichier
      reader.readAsDataURL(file)
    },

    /** for carteGriseFile & plainteFile */
    async deleteFileFromPreview(imageType) {
      if (imageType === "carteGriseFile") {
        this.pdfPreviewCarteGriseFile = null
        this.imagePreviewCarteGriseFile = null
        this.resetFileObject('carteGriseFile', true)

      } else if (imageType === "plainteFile") {
        this.pdfPreviewPlainteFile = null
        this.imagePreviewPlainteFile = null
        this.resetFileObject('plainteFile', true)
      }
    },

    resetFileObject(fileObjectName, resettingFileInput) {
      if (resettingFileInput) {
        this[fileObjectName].value = null
        this[fileObjectName].fileName = null
      }
      if (this[fileObjectName] && this[fileObjectName].url && typeof this[fileObjectName].url === 'string' && this[fileObjectName].url.startsWith('blob:')) {
        try { window.URL.revokeObjectURL(this[fileObjectName].url) } catch (e) {}
        if (this._blobUrls) this._blobUrls = this._blobUrls.filter(u => u !== this[fileObjectName].url)
      }
      this[fileObjectName].state = null
      this[fileObjectName].invalidFeedback = null
      this[fileObjectName].id = null
      this[fileObjectName].url = null
    },

  },
}
</script>

<style scoped>
/* pour affichage desktop (md) : scroll pas sur la page entière mais sur le contenu modifiable uniquement */
@media (min-width: 769px) {
  #annonce-create-step-right-part {
    height: 100%;
    overflow: auto;
  }

  #annonce-create-step-right-part-inside {
    padding-left: 3px; /* pour voir le border sur les input focus */
    width: 100%;
    margin-bottom: auto; /* si il n'y a pas assez d'items pour remplir la hauteur */
  }
}

.custom-span-files-mandatory {
  font-size: 14px;
  font-weight: 500;
  display: block;
  color: var(--main-grey-medium);
}

</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceCreate/AnnonceCreateStep7.vue